// @ts-nocheck
import Page from "@insite/mobius/Page";
import styled from "styled-components";

const mobileQuery = "@media (max-width: 768px)";
const PageWithMobileOverFlow = styled(Page)`
    ${mobileQuery} {
        overflow: scroll !important;
    }
`;

export default PageWithMobileOverFlow;
